import { render } from "./SiteHeader.vue?vue&type=template&id=49bfc732&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"

import "./SiteHeader.vue?vue&type=style&index=0&id=49bfc732&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bfc732"]])

export default __exports__